import React from 'react';
import { SvgIcon } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  root: {
    width: '0.9375rem',
    height: '0.9375rem',
  },
  rootMobile: {
    width: '1.125rem',
    height: '1.125rem',
  },
}));

const ImageIcon = (props) => {
  const classes = useStyles();
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 30 30"
      classes={{
        //eslint-disable-next-line
        root: props.isMobile ? classes.rootMobile : classes.root,
      }}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.8889 2H1.11112C0.497476 2 0 2.49536 0 3.10639V26.8936C0 27.5046 0.497476 28 1.11112 28H28.8889C29.5025 28 30 27.5046 30 26.8936V3.10639C30 2.49536 29.5025 2 28.8889 2ZM6.66696 10.2979C8.20106 10.2979 9.44474 9.05953 9.44474 7.53195C9.44474 6.00434 8.20106 4.76599 6.66696 4.76599C5.13281 4.76599 3.88918 6.00434 3.88918 7.53195C3.88918 9.05953 5.13281 10.2979 6.66696 10.2979ZM9.05521 17.4893C5.333 17.4893 1.66631 24.7915 1.66631 26.3404H28.333C28.333 25.1234 24.6663 10.851 20.5553 10.851C17.9741 10.851 16.5756 14.7761 15.5346 17.6976C14.9175 19.4294 14.4261 20.8085 13.8885 20.8085C13.3341 20.8085 13.0416 20.3195 12.6812 19.7169C12.1025 18.7495 11.3487 17.4893 9.05521 17.4893Z"
      />
    </SvgIcon>
  );
};

export default ImageIcon;
